import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    loading: false,
    error: undefined
} 

const authReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_COUNTRIES_REQUEST": 
            return { ...state, loading: true }
        case "GET_COUNTRIES_SUCCESS":
            let { countries } = action.payload.data
            for (let country of countries) {
                state.byIds[country.id] = country
                if (state.allIds.indexOf(country.id) === -1) state.allIds.push(country.id);
            }
            return { error: undefined, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        case "GET_COUNTRIES_FAILED":
            return { error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default authReducer;